import { Component, HostListener, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface PhotoViewerImage {
  id: string;
  title: string;
  url: string;
}

export interface MediaLibraryPhotoViewerDialogData {
  images: PhotoViewerImage[];
  selectedIndex: number;
}

@Component({
  selector: 'app-media-library-photo-viewer-dialog',
  templateUrl: './media-library-photo-viewer-dialog.component.html',
  styleUrls: ['./media-library-photo-viewer-dialog.component.scss']
})
export class MediaLibraryPhotoViewerDialogComponent {
  currentIndex = 0;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: MediaLibraryPhotoViewerDialogData,
    private dialogRef: MatDialogRef<MediaLibraryPhotoViewerDialogComponent>
  ) {
    const maxIndex = Math.max((data.images?.length || 1) - 1, 0);
    this.currentIndex = Math.min(Math.max(data.selectedIndex || 0, 0), maxIndex);
  }

  get currentImage(): PhotoViewerImage | null {
    return this.data.images?.[this.currentIndex] || null;
  }

  next(): void {
    if (!this.data.images?.length) return;
    this.currentIndex = (this.currentIndex + 1) % this.data.images.length;
  }

  prev(): void {
    if (!this.data.images?.length) return;
    this.currentIndex = (this.currentIndex - 1 + this.data.images.length) % this.data.images.length;
  }

  close(): void {
    this.dialogRef.close();
  }

  @HostListener('window:keydown.escape')
  onEscape(): void {
    this.close();
  }

  @HostListener('window:keydown.arrowright')
  onArrowRight(): void {
    this.next();
  }

  @HostListener('window:keydown.arrowleft')
  onArrowLeft(): void {
    this.prev();
  }
}
